<div class="confirmation-page w-100 d-flex justify-content-center align-items-center background-grey">
    <div class="d-flex p-4">
        <mat-card appearance="outlined" class="px-4 mat-elevation-z2">
            <div class="d-flex align-items-center justify-content-center my-4">
                <app-image-loader
                    [src]="'assets/' + facilityName + '/img/payment-confirmation.webp'"
                    alt="confirmation_check"
                    width="186"
                    height="171"
                    [priority]="true"
                />
            </div>
            @if (!!countPaymentErrors) {
                <lib-banner [banner]="banner" />
                <div class="col-12 error-information">
                    <div class="d-flex justify-content-center">
                        <button mat-flat-button color="primary" (click)="goToCart()">GO TO CART</button>
                    </div>
                </div>

                <div class="col-12">
                    <section class="successBanner">
                        <h4 class="mat-headline-4 d-block text-center mt-4 mb-3 payment-confirmation-title">
                            {{ countPaymentSuccessful || 0 }} of {{ totalPayments }} payment(s) were created
                            successfully.
                        </h4>
                        <span class="mat-subtitle-1 mb-4 d-block text-center payment-confirmation-subtitle"
                            >Download your receipts below</span
                        >
                    </section>
                </div>
            } @else {
                <p class="mat-headline-4 title-card">Your payment was successful!</p>
            }
            <div class="d-flex flex-wrap justify-content-center confirmation-card-info-container">
                <div class="flex-grow-1 confirmation-card-info px-4 py-2 m-1 me-md-2">
                    <h1 class="mb-1">Your confirmation number(s) is</h1>
                    <div class="d-flex justify-content-center">
                        <div class="completedPaymentList text-center">
                            @if (!!uniquePayments.length) {
                                @for (vendorInvoiceNumber of uniquePayments; track vendorInvoiceNumber) {
                                    <div>
                                        <h3 class="mat-subtitle-1 primary confirmation-card-info-text m-0 mx-1">
                                            {{ vendorInvoiceNumber }}
                                        </h3>
                                    </div>
                                }
                            } @else {
                                @if (!!records.length) {
                                    @for (record of records; let recordIndex = $index; track recordIndex) {
                                        <div>
                                            <h3 class="mat-subtitle-1 primary confirmation-card-info-text m-0 mx-1">
                                                R-{{ record }}
                                            </h3>
                                        </div>
                                    }
                                }
                            }
                        </div>
                    </div>
                </div>
                @if (notificationEmail && showReceiptSent()) {
                    <div class="flex-grow-1 confirmation-card-info px-4 py-2 m-1 me-md-2">
                        <h1 class="mb-1">Your payment receipt was sent to</h1>
                        <h3 class="mat-subtitle-1 primary confirmation-card-info-text m-0">
                            {{ notificationEmail }}
                        </h3>
                    </div>
                }
            </div>
            <ng-content select="[body]" />
            <div class="d-flex justify-content-center mt-5 mb-2">
                @if (transactionsIds.length) {
                    <button
                        id="btn-download"
                        mat-flat-button
                        type="submit"
                        color="primary"
                        (click)="getReceipt()"
                        [disabled]="disabledButton() || isDownloading"
                        *appHideDownload
                    >
                        <span> {{ isDownloading ? 'DOWNLOADING' : paymentReceiptText }} </span>
                        @if (isDownloading) {
                            <mat-icon class="ms-2 spinner-icon" iconPositionEnd>
                                <mat-spinner diameter="16" />
                            </mat-icon>
                        }
                    </button>
                }
            </div>
            <div class="d-flex justify-content-center mt-2">
                @if (transactionsIds.length) {
                    <button
                        id="btn-back"
                        matButton="outlined"
                        color="primary"
                        (click)="backTo()"
                        class="button primary btn-back"
                        type="button"
                    >
                        BACK TO NEW SEARCH
                    </button>
                }
            </div>
            <ng-content select="[footer]" />
        </mat-card>
    </div>
</div>
